// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__uBYJx","modalBody":"addForm_modalBody__cJ+7n","formControl":"addForm_formControl__OxNUb","add":"addForm_add__3utyp"};